import { getStoredCredentials } from "../../hooks/ui/customerDataStore";
import { getInsuranceQueryOptions } from "../../hooks/api/useGetInsuranceById";
import {
  createFileRoute,
  redirect,
  isRedirect,
  useRouter,
} from "@tanstack/react-router";
import { LoaderComponent } from "../../components/loaderComponent";
import ErrorComponent from "../../components/errorComponent";
import { useCustomerInsuranceStore } from "../../hooks/ui/customerInsuranceStore";
import { Anchor, Text, Title } from "@mantine/core";
import ContactUsPaper from "../../components/contactUsPaper";
import InsuranceDetails from "../../components/insuranceDetails";
import InsuranceElement from "../../components/insuranceElement";
import PoaExpiredBanner from "../../components/poaValidation";
import { REPLAY_BLOCK_CLASS } from "../../utils/statsig";

export const Route = createFileRoute("/$insuranceIdentifier/information")({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const credentials = context.credentials?.sessionToken
      ? context.credentials
      : getStoredCredentials();

    if (!credentials?.sessionToken) {
      throw redirect({ to: "/login" });
    }

    const insuranceIdentifier = params.insuranceIdentifier;
    try {
      const response = await Promise.all([
        context.queryClient.ensureQueryData(
          getInsuranceQueryOptions(credentials, insuranceIdentifier),
        ),
      ]);

      // Update store with customer data
      const { updateInsurance } = useCustomerInsuranceStore.getState();

      await updateInsurance(response[0]);

      return response[0];
    } catch (err) {
      if (isRedirect(err)) throw err; // ✅ DO NOT swallow redirects

      throw redirect({ to: "/login", search: true });
    }
  },
  pendingComponent: () => <LoaderComponent />,
  errorComponent: () => <ErrorComponent />,
});

function RouteComponent() {
  const router = useRouter();
  const insurance = Route.useLoaderData();

  return (
    <>
      <Anchor
        component="button"
        onClick={() => router.history.back()}
        style={{ cursor: "pointer" }}
        c="var(--wallet-color-neutrals-black)"
        mt={"xl"}
      >
        ← Tillbaka
      </Anchor>
      <PoaExpiredBanner />

      <Title ff={"var(--wallet-font-family-sambla-sans)"} mt={"xl"} order={1}>
        Försäkring{" "}
        <span className={REPLAY_BLOCK_CLASS}>
          {insurance.insuranceIdentifier}
        </span>
      </Title>
      <Text mb={"xl"}>Här ser du din försäkringsinformation.</Text>
      <InsuranceDetails />
      <InsuranceElement />
      <ContactUsPaper />
    </>
  );
}
